export default __webpack_public_path__ + "static/media/Pierre.958392cd.png";